const axios = require("axios");
const querystring = require("querystring");
const { Notification } = require("nice-design");

const TOWORDS_TOKEN = localStorage.token;
const token = () => {
  if (TOWORDS_TOKEN) return TOWORDS_TOKEN;
  return localStorage.getItem("token");
};

function createHttp({ type, baseURL, token }) {
  const Http = axios.create({
    baseURL: baseURL ? baseURL : "", //api host：api的请求基础地质
    timeout: 1000 * 60 * 5, // 超时时间ms
    withCredentials: false,
    headers: {
      common: {
        Authorization: token,
        "X-Client": "towords-book",
      } /* ,
            post:{
                'Content-Type':'application/x-www-form-urlencoded'
            } */,
    },
  });
  return function ({ url, params, is_qs, headers }) {
    let data = params || {};
    if (is_qs) {
      data = querystring.stringify(data);
    }
    let config = {
      url,
      data,
      method: type,
    };
    if (headers) {
      config.headers = headers;
    }
    return new Promise((resolve, reject) => {
      Http(config)
        .then((res) => {
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
}

// 统一把 axios 的成功响应 / 各类错误规整成业务可消费的对象，
// 避免超时、断网时读取 undefined.response.data 抛出 TypeError 导致整个流程崩溃
function normalizeResponse(data, wrapData = false) {
  // 正常响应
  if (data && data.status === 200) {
    return data.data;
  }

  // axios 抛出的错误（超时、断网、非 2xx 等）
  const isAxiosError =
    data && (data.isAxiosError || data.code || typeof data.message === "string");

  if (isAxiosError) {
    const isTimeout =
      data.code === "ECONNABORTED" ||
      /timeout/i.test(String(data.message || ""));
    if (isTimeout) {
      return {
        success: false,
        code: "TIMEOUT",
        timeout: true,
        message: "请求超时，请重试",
      };
    }

    // 服务端返回了非 2xx，但有响应体
    if (data.response) {
      return wrapData
        ? { status: data.response.status, data: data.response.data }
        : { status: data.response.status, ...(data.response.data || {}) };
    }

    // 没有响应体，通常是网络异常
    return {
      success: false,
      code: "NETWORK_ERROR",
      network: true,
      message: "网络异常，请检查网络后重试",
    };
  }

  return { success: false, message: "请求失败" };
}

async function postCtrl(opt) {
  let config = Object.assign(
    {
      url: "",
      params: {},
      is_qs: false,
    },
    opt
  );
  const _post = createHttp({
    type: "post",
    baseURL: config.baseURL ? config.baseURL : "",
    token: config.token,
  });
  const data = await _post(config).catch((err) => {
    return err;
  });
  return normalizeResponse(data);
}

async function getCtrl(opt) {
  let config = Object.assign(
    {
      url: "",
      params: {},
      is_qs: false,
    },
    opt
  );
  const _get = createHttp({
    type: "get",
    baseURL: config.baseURL ? config.baseURL : "",
  });
  const data = await _get(config).catch((err) => {
    return err;
  });
  return normalizeResponse(data, true);
}
const $postApi = async (url, params = {}) => {
  const is_qs = true;
  const res = await postCtrl({
    url,
    params,
    is_qs,
    baseURL: "https://api.towords.net",
  });
  return res;
};
const $post = async (url, params, headers) => {
  const res = await postCtrl({
    url,
    params,
    token: `Bearer ${token()}`,
    headers: { "X-Client": "towords-book", ...(headers || {}) },
  });
  if (res.status === 401) {
    window.location.href = `/login?refer=${encodeURIComponent(
      window.location.href
    )}`;
  } else {
    return res;
  }
};
export const _post = createHttp("post");
export const $postNode = async (url, params) => {
  let config = {
    url,
    params,
    is_qs: false,
  };
  const data = await _post(config).catch((err) => {
    return err;
  });
  const res = normalizeResponse(data, true);
  if (res && res.status === 401) {
    window.location.href = `/login?refer=${encodeURIComponent(
      window.location.href
    )}`;
    return;
  }
  return res;
};

export const $postBody = async (url, params) => {
  let config = {
    url,
    params,
    is_qs: false,
    baseURL: "https://api.towords.net",
  };
  const _post = createHttp({
    type: "post",
    baseURL: config.baseURL ? config.baseURL : "",
    token: config.token,
  });
  const data = await _post(config).catch((err) => {
    return err;
  });
  return normalizeResponse(data, true);
};

const $get = async (url, params) => {
  const data = await axios({
    method: "get",
    url:
      process.env.NODE_ENV === "development"
        ? url
        : `https://api.towords.net${url}`,
    params: params,
  }).catch((err) => err);
  return normalizeResponse(data, true);
};

export { $post, $postApi, $get };
